import Profile from 'models/Profile';
import { ProfileOptions } from 'models/Profile';
import http from 'services/http';

const profileIncludes = [
  'client.leaf_descendants',
  'scopes',
  'preferences',
  'acting_client.group_types',
  'acting_client.client_group_types.group_type',
  'acting_client.enabled_provider_types',
  'acting_client.unowned_collaborations',
  'acting_client.manager_group_types_in_network',
  'enabled_provider_types',
  'managed_provider_types',
  'provided_provider_types',
  'selected_provider_types',
  'selected_groups',
  'allowed_group_ids',
].join(',');

export async function updateProfile(params: Partial<Profile>) {
  return http
    .put<ProfileOptions>(`/me`, {
      ...params,
      include: profileIncludes,
    })
    .then((response) => new Profile(response.data));
}

export async function showProfile() {
  return http
    .get<ProfileOptions>(`/me/profile?include=${profileIncludes}`)
    .then((response) => new Profile(response.data));
}
